import { Box } from '@breathelife/mui';
import styled from '../../../../Styles/themed-styled-components';

export const TabsContainer = styled(Box)`
  && {
    border-color: ${(props) => props.theme.colors.grey[40]};
    box-shadow: 0 1px 5px rgba(9, 30, 66, 0.05);
  }
`;
